// stores/columnStore.ts
import { defineStore } from "pinia"

export const useColumnStore = defineStore("columnStore", {
  state: () => ({
    columnConfigs: {} as Record<string, any[]>
  }),

  persist: true,   // 🔥 THIS is all you need with your plugin

  actions: {
    setColumns(endpoint: string, columns: any[]) {
      if (!endpoint) return
      this.columnConfigs[endpoint] = columns
    },

    getColumns(endpoint: string) {
      if (!endpoint) return undefined
      return this.columnConfigs[endpoint]
    },

    cleanupStaleKeys() {
      delete this.columnConfigs["undefined"]
      delete this.columnConfigs["null"]
    }
  }
})